/* eslint-disable camelcase */
import { defaults } from 'helpers/cameras/coreCameraProps'
import { CONVENTIONAL, CORRIDOR } from 'helpers/globals'
import resolutions from './resolutions'
import sceneInfo from './sceneInfo'
import cameraModelInfo from './cameraModelInfo'
import compose from 'ramda/src/compose'
import path from 'ramda/src/path'
import filter from 'ramda/src/filter'
import evolve from 'ramda/src/evolve'
import when from 'ramda/src/when'
import { stringToBoolean, objToNumber, mappedIndex } from './general'
import getImagerSize from 'helpers/cameras/getImagerSize'

const filterCameras = c => !!c.camera_position

const fallback = (key, log = true) => when(val => !val, _ => {
  const fallbackVal = defaults[key]
  return (log && console.log(`FALLBACK USED FOR ${key}: ${fallbackVal}`)) || fallbackVal
})

const fallbackTransformations = {
  notes: fallback('notes', false),
  unitOfMeasurement: fallback('unitOfMeasurement'),
  imagerSize: fallback('imagerSize'),
  distance: fallback('distance'),
  horizontalAngleOfView: fallback('horizontalAngleOfView'),
  cameraHeight: fallback('cameraHeight'),
  sceneHeight: fallback('sceneHeight'),
  tilt: fallback('tilt', false)
}

const migrateCamera = async (camera, index) => {
  const { notes, imager_size, distance, aov, resolution, camera_height, tilt, fov_mode, camera_position,
    subject_position, fov_image, title, locked, selected_camera_configuration, unit, fov_image_is_user_selected,
  camera_mode_enabled, display_ir_line, fov_position } = camera

  if (!camera_position) return {}

  const modelInfo = await cameraModelInfo(camera_mode_enabled, selected_camera_configuration)

  return {
    locked: stringToBoolean(locked),
    notes: notes,
    imagerCount: defaults.imagerCount,
    location: objToNumber(camera_position),
    unitOfMeasurement: unit,
    name: title || `Camera ${index + 1}`,
    imagerSize: getImagerSize(imager_size),
    distance: parseFloat(distance),
    horizontalAngleOfView: parseFloat(aov),
    cameraHeight: parseFloat(camera_height),
    sceneHeight: parseFloat(camera_height),
    tilt: parseFloat(tilt),
    id: index + 1,
    heading: google.maps.geometry.spherical.computeHeading(
      new google.maps.LatLng(objToNumber(camera_position)),
      new google.maps.LatLng(objToNumber(subject_position))
    ),
    active: index === 0,
    fovMode: fov_mode === 'corridor' ? CORRIDOR : CONVENTIONAL,
    displayIrLine: stringToBoolean(display_ir_line),
    ...sceneInfo(fov_image, fov_position, fov_image_is_user_selected),
    ...resolutions(resolution, selected_camera_configuration),
    ...modelInfo
  }
}

export default async (project) => {
  const filteredCameras = compose(filter(filterCameras),
                                  Object.values,
                                  path(['parameters', 'cameras'])
                                )(project)
  const promises = filteredCameras.map(async (c, i) => {
    const cam = await migrateCamera(c, i)
    return evolve(fallbackTransformations, cam)
  })
  return await Promise.all(promises)
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/migrateCameras.js